import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IThoiKhoaBieuViewActionTypes, eIThoiKhoaBieuViewActionTypeIds } from "../../action-types/thoi-khoa-bieu/IThoiKhoaBieuViewActionType";
import { IThoiKhoaBieuViewPageState } from "../../page-state-model/thoi-khoa-bieu/IThoiKhoaBieuViewPageState";

const iniState: IThoiKhoaBieuViewPageState = {
    status: ePageBaseStatus.is_not_initialization,
    pl_tkb_chitiets: [],
    request: {
        dm_lop_ids: [],
        dm_phong_ids: [],
        dm_truong_id: 0,
        hoc_ky: 0,
        nam_hoc: "",
        sis_giaovien_ids: [],
        tuan_thu: 0,
    },
    view_mode: "lop"
}

export const thoiKhoaBieuViewReducer = (state: IThoiKhoaBieuViewPageState=iniState, action: IThoiKhoaBieuViewActionTypes): IThoiKhoaBieuViewPageState => {
    switch (action.type) {
        case eIThoiKhoaBieuViewActionTypeIds.CHANGE_VIEW_MODE:
            return {
                ...state,
                view_mode: action.payload
            }
        case eIThoiKhoaBieuViewActionTypeIds.CHANGE_REQUEST:
            return {
                ...state,
                request: action.payload,
                status: ePageBaseStatus.is_need_reload
            }
        case eIThoiKhoaBieuViewActionTypeIds.LOAD_START:
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case eIThoiKhoaBieuViewActionTypeIds.LOAD_SUCCESS:
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                pl_tkb_chitiets: action.payload
            }
        case eIThoiKhoaBieuViewActionTypeIds.LOAD_ERROR:
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                pl_tkb_chitiets: []
            }

        default:
            return {
                ...state
            }
    }
}